<div
class="navbar navbar--blue container-offcanvas"
[ngClass]="{
  'container-offcanvas--on': menuOpened,
  'navbar--blue': !onProjectPage()
}"
>
  <div class="container-fluid">
    <div class="row flex-nowrap flex-grow-1">
      <div class="col d-md-none">
        <button
          class="btn--link navbar-menu-toggle"
          (click)="menuOpened = !menuOpened"
          type="button"
        >
          MENU
        </button>
      </div>
      <div class="navbar-left-menu">
        <div class="ab-navbar-link-container">
          <div class="ab-navbar-link" uiSrefActive="ab-navbar-link--active">
            <a
              class="ab-navbar-link__btn btn btn--primary"
              (click)="closeMenu()"
              uiSref="account-overview"
              title="Account Dashboard"
            >
              <i
                class="ab-navbar-link__icon ml-0 glyphicon glyphicon-ab-logo"
              ></i>
              <span class="ab-navbar-link__btn-text">Dashboard</span>
            </a>
          </div>
        </div>
        <div class="project-nav-info">
          <div
            class="d-flex flex-shrink-0"
            ui-view="project-language-icon"
          ></div>
          <div class="project-picker-wrapper" ui-view="project-picker"></div>
        </div>
        <div class="project-nav" ui-view="project-nav"></div>
        <div
          class="onboarding-progress-wrapper"
          *ngIf="showIndicator"
          (click)="showOnboardingChecklist()"
          ui-view="onboarding-progress"
        ></div>
        <ng-container *ngIf="showInstallAirbrakeButton === true && onProjectPage()">
          <div class="ab-navbar-link-container d-md-none">
            <div class="ab-navbar-link">
              <a
              class="ab-navbar-link__btn btn btn--secondary btn--xsmall mr-2"
              (click)="showInstructionsModal()"
            >Install Airbrake</a>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showSendDataButton === true && onProjectPage()">
          <div class="ab-navbar-link-container d-md-none">
            <div class="ab-navbar-link">
              <a
              class="ab-navbar-link__btn btn btn--secondary btn--xsmall mr-2"
              (click)="showSendDataModal()"
            >Send Data</a>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showStopSendingDataButton() && onProjectPage()">
          <div class="ab-navbar-link-container d-md-none">
            <div class="ab-navbar-link">
              <a
              class="ab-navbar-link__btn btn btn--secondary btn--xsmall mr-2"
              (click)="stopSendingData()"
            >Stop sending demo data</a>
            </div>
          </div>
        </ng-container>
      </div>
      <div
        class="col d-flex align-items-center justify-content-center d-md-none"
      >
        <a class="ab-navbar-brand" href="/" title="Airbrake">
          <i class="ab-navbar-brand__logo glyphicon glyphicon-ab-logo"></i>
        </a>
      </div>

      <div
        class="col col-md-auto ml-md-auto d-flex align-items-center justify-content-end"
      >
        <ng-container *ngIf="showInstallAirbrakeButton === true && onProjectPage()">
          <span class="d-none d-md-inline">
            <a
              class="btn btn--secondary btn--xsmall mr-2"
              (click)="showInstructionsModal()"
            >Install Airbrake</a>
          </span>
        </ng-container>

        <ng-container *ngIf="showSendDataButton === true && onProjectPage()">
          <span class="d-none d-md-inline">
            <a
              class="btn btn--secondary btn--xsmall mr-2"
              (click)="showSendDataModal()"
            >Send Data</a>
          </span>
        </ng-container>

        <ng-container *ngIf="showStopSendingDataButton() && onProjectPage()">
          <span class="d-none d-md-inline">
            <ng-container *ngIf="stoppingSendData">
              Stopping sending data...
            </ng-container>

            <ng-container *ngIf="!stoppingSendData">
              Sending demo data until {{ demoModeUntilDate | date: 'MMM d, y'}}
            </ng-container>

            <a
              class="btn btn--secondary btn--xsmall mr-2"
              [ngClass]="{ disabled: stoppingSendData }"
              (click)="stopSendingData()"
            >Stop</a>
          </span>
        </ng-container>

        <ng-container *ngIf="showUpgradeCta === true">
          <span class="d-none d-md-inline">
            <a
              href="/account/plan/edit"
              target="_self"
              class="btn btn--neutral btn--xsmall mr-2"
            >
              <ng-container *ngIf="unconvertedTrial === true">
                <strong>
                  {{ trialDaysRemaining }}
                  {{ trialDaysRemaining | pluralize: "Day" }}
                </strong>
                left in trial
              </ng-container>

              <ng-container *ngIf="onFreeDevPlan === true">
                <strong>Upgrade your plan</strong>
              </ng-container>
            </a>
          </span>
        </ng-container>

        <ng-container *ngIf="currentTheme === 'light'">
          <button id="mode-dark" class="btn-color-mode btn float-md-right" type="button" aria-label="Toggle user interface mode to dark" (click)="changeColorMode('dark')">
            <span class="toggle-dark"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg></span>
          </button>
        </ng-container>

        <ng-container *ngIf="currentTheme === 'dark'" >
          <button id="mode-light" class="btn-color-mode btn float-md-right" type="button" aria-label="Toggle user interface mode to light" (click)="changeColorMode('light')">
            <span class="toggle-light"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg></span>
          </button>
        </ng-container>

        <div
          class="dropdown user-dropdown float-md-right"
          ngbDropdown="ngbDropdown"
        >
          <div ui-view="onboarding-checklist"></div>

          <a
            class="user-name dropdown-toggle"
            ngbDropdownToggle="ngbDropdownToggle"
          >
            <div class="user-dropdown__avatar">
              <ab-gravatar
                class="avatar avatar--small"
                [user]="user"
                [size]="24"
              ></ab-gravatar>
              <span class="checklist-indicator" *ngIf="showIndicator"></span>
            </div>
            <span
              *ngIf="showUpgradeCta === false"
              class="text-truncate d-none d-md-inline d-md-none d-lg-inline"
            >
              &nbsp;{{ user.nameOrEmail }}
            </span>
          </a>

          <ul ngbDropdownMenu="ngbDropdownMenu">
            <li>
              <a
                href="/users/{{ user.id }}/edit"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                ><i class="glyphicon glyphicon-envelope"></i>Profile &amp;
                notifications</a
              >
            </li>
            <li>
              <a
                href="/account/edit"
                *ngIf="user.admin"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                ><i class="glyphicon glyphicon-credit-card"></i>Account &amp;
                billing</a
              >
            </li>
            <li>
              <a
                href="/users"
                *ngIf="user.admin"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                ><i class="glyphicon glyphicon-user"></i>Users</a
              >
            </li>
            <li>
              <a
                href="/teams"
                *ngIf="user.admin"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                >
                <i class="glyphicon glyphicon-group"></i>Teams</a
              >
            </li>
            <li>
              <a
                href="/audit_logs"
                *ngIf="user.admin"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                >Audit Logs</a
              >
            </li>
            <li>
              <a
                href="/account/plan/edit"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                >Plan options</a
              >
            </li>
            <li>
              <a
                class="logout"
                (click)="logout()"
                ngbDropdownItem="ngbDropdownItem"
                >Log out</a
              >
            </li>
            <hr />
            <li *ngIf="$state.includes('errors')">
              <a
                (click)="showShortcutsModal()"
                tabindex="-1"
                ngbDropdownItem="ngbDropdownItem"
                >Keyboard Shortcuts</a
              >
            </li>
            <li>
              <ab-external-link
                href="http://status.airbrake.io"
                tabindex="-1"
                ngbDropdownItem="ngbDropdownItem"
                >Airbrake Status</ab-external-link
              >
            </li>
            <li>
              <ab-external-link
                href="https://docs.airbrake.io"
                tabindex="-1"
                ngbDropdownItem="ngbDropdownItem"
                >Help Docs</ab-external-link
              >
            </li>
            <li>
              <a
                href="mailto:support@airbrake.io"
                target="_self"
                ngbDropdownItem="ngbDropdownItem"
                >Email Support</a
              >
            </li>
            <li>
              <ab-external-link
                href="https://airbrake.io/blog/"
                tabindex="-1"
                ngbDropdownItem="ngbDropdownItem"
                >Official Blog</ab-external-link
              >
            </li>
            <li>
              <a
                (click)="showOnboardingChecklist()"
                [ngClass]="{ highlight: showIndicator }"
                *ngIf="onProjectPage()"
                tabindex="-1"
                ngbDropdownItem="ngbDropdownItem"
                >Set Up Airbrake</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  ui-view="main"
  class="dashboard container-offcanvas"
  [ngClass]="{ 'container-offcanvas--on': menuOpened }"
></div>
